import img0 from '../../assets/certificates/1.png';
import img1 from '../../assets/certificates/2.jpg';


export const Data = [
  img0,
  img1,
 
];